import { createStaticDataProvider } from '@adv-frontend/data-provider';
import { createFilterSelectWithSuggest, OperatorType } from '@adv-frontend/filters';
import { type OpenApiSchemaExternalSystemType } from '#shared/api/schema';
import { OZON_SERVICE_NAME } from '#shared/lib/brand';
import { HAS_FEEDBACK_SOURCE_FILTER_ID, HAS_FEEDBACK_SOURCE_FILTER_TITLE } from '../../constants';

type FeedbackSourceType = Extract<OpenApiSchemaExternalSystemType, 'ozon_sku' | 'yandex_market'>;

type FeedbackSourceItem = {
    id: FeedbackSourceType;
    label: string;
};

const items: FeedbackSourceItem[] = [
    { id: 'ozon_sku', label: OZON_SERVICE_NAME },
    { id: 'yandex_market', label: 'Яндекс Маркет' },
];

export const createFeedbackSourceFilter = () => {
    const itemById = new Map<string, FeedbackSourceItem>(items.map((item) => [item.id, item]));
    const dataProvider = createStaticDataProvider(items);
    const valueType = Object.fromEntries(items.map(({ id }) => [id, id])) as Record<string, FeedbackSourceType>;

    return createFilterSelectWithSuggest<typeof HAS_FEEDBACK_SOURCE_FILTER_ID, FeedbackSourceItem, FeedbackSourceType>({
        id: HAS_FEEDBACK_SOURCE_FILTER_ID,
        title: HAS_FEEDBACK_SOURCE_FILTER_TITLE,
        operators: [OperatorType.Eq, OperatorType.Ne],
        operatorTitles: {
            [OperatorType.Eq]: 'Есть отзывы',
            [OperatorType.Ne]: 'Нет отзывов',
        },
        valueType,
        suggestProps: {
            dataProvider: (props) => props.children(dataProvider),
            useTitleByValue: (values) =>
                values.map((value) => {
                    return {
                        value,
                        title: itemById.get(value)?.label ?? value,
                    };
                }),
            renderSelectListItem: ({ item }) => item.label,
            renderFilterChipsItem: ({ item }) => item.label,
        },
    });
};
